import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './i18n'; // 初始化i18n
import ErrorBoundary from './components/ErrorBoundary';
import PageLayout from './components/PageLayout';
import { ThemeProvider } from './context/ThemeContext';
import Header from './Header';
import MainContent from './MainContent';
import ConnectUs from './ConnectUs';
import { useDocumentTitle } from './hooks/useDocumentTitle';

// 服务页面
import MarketExpansion from './pages/services/MarketExpansion';
import StrategicPlanning from './pages/services/StrategicPlanning';
import InvestmentAnalysis from './pages/services/InvestmentAnalysis';
import PolicyCompliance from './pages/services/PolicyCompliance';
import RiskAssessment from './pages/services/RiskAssessment';
// import LocalizationStrategy from './pages/services/LocalizationStrategy';

// 洞察页面
import AllInsights from './pages/insights/AllInsights';
import FeaturedInsights from './pages/insights/FeaturedInsights';
import MarketResearch from './pages/insights/MarketResearch';
import IndustryAnalysis from './pages/insights/IndustryAnalysis';
import WhitePapers from './pages/insights/WhitePapers';
import BusinessNews from './pages/insights/BusinessNews';
import InsightDetail from './pages/insights/InsightDetail';

// 案例研究页面
import AllCases from './pages/case-studies/AllCases';
import CaseStudyDetail from './pages/case-studies/CaseStudyDetail';

// 关于我们页面
import CompanyProfile from './pages/about/CompanyProfile';
import OurTeam from './pages/about/OurTeam';
import OurHistory from './pages/about/OurHistory';
import Certifications from './pages/about/Certifications';

// 首页组件
function HomePage() {
  useDocumentTitle('', true); // 使用默认标题
  
  return (
    <>
      <Header />
      <MainContent />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <div className="App">
            <PageLayout>
              <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/connect-us" element={<ConnectUs />} />
              
              {/* 服务路由 */}
              <Route path="/services/market-expansion" element={<MarketExpansion />} />
              <Route path="/services/strategic-planning" element={<StrategicPlanning />} />
              <Route path="/services/investment-analysis" element={<InvestmentAnalysis />} />
              <Route path="/services/policy-compliance" element={<PolicyCompliance />} />
              <Route path="/services/risk-assessment" element={<RiskAssessment />} />
              {/* <Route path="/services/localization-strategy" element={<LocalizationStrategy />} /> */}
              
              {/* 洞察路由 */}
              <Route path="/insights/all" element={<AllInsights />} />
              <Route path="/insights/featured" element={<FeaturedInsights />} />
              <Route path="/insights/market-research" element={<MarketResearch />} />
              <Route path="/insights/industry-analysis" element={<IndustryAnalysis />} />
              <Route path="/insights/white-papers" element={<WhitePapers />} />
              <Route path="/insights/business-news" element={<BusinessNews />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              
              {/* 案例研究路由 */}
              <Route path="/case-studies/all" element={<AllCases />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              
              {/* 关于我们路由 */}
              <Route path="/about/company-profile" element={<CompanyProfile />} />
              <Route path="/about/our-team" element={<OurTeam />} />
              <Route path="/about/our-history" element={<OurHistory />} />
              <Route path="/about/certifications" element={<Certifications />} />
              </Routes>
            </PageLayout>
          </div>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
